module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/series/de-DE/img_series-113.png";